"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ErrorBase = _interopRequireDefault(require("./_ErrorBase"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var ServerError = function ServerError() {
  return /*#__PURE__*/_react.default.createElement(_ErrorBase.default, null);
};
var _default = exports.default = ServerError;